import { isEmpty, sortBy } from "lodash";

export const sortOrgs = (list, sortByOptions) => {
  return !isEmpty(sortByOptions) ? sortBy(list, sortByOptions) : list;
};
